import { render, staticRenderFns } from "./Coachmodification.vue?vue&type=template&id=31e3edfa&scoped=true&"
import script from "./Coachmodification.vue?vue&type=script&lang=js&"
export * from "./Coachmodification.vue?vue&type=script&lang=js&"
import style0 from "./Coachmodification.vue?vue&type=style&index=0&id=31e3edfa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e3edfa",
  null
  
)

export default component.exports